
















import mixins from 'vue-typed-mixins';
import {
  ReportNode,
  ReportStore,
  SectionData,
  PageData,
  QuestionData,
  ReportContext,
} from '@/utils/ReportUtils';
import SurveyUtils, {
  Survey,
  Page,
  Question,
  Section,
  SurveyParticipation,
  SurveyState,
} from '@/utils/SurveyUtils';
import { v4 as uuidv4 } from 'uuid';
import SubOrganizationUtils, {
  SubOrganization,
} from '@/utils/SubOrganizationUtils';
import PointsOfServiceUtils, {
  PointsOfService,
} from '@/utils/PointsOfServiceUtils';
import SectionVue from './nodes/Section.vue';
import RootVue from './nodes/Root.vue';
import DocumentsVue from './nodes/Documents.vue';
import ResourcesVue from './nodes/Resources.vue';
import SurveyNodeUtils from '@/utils/SurveyNodeUtils';
export default mixins().extend({
  components: {
    node_section: SectionVue,
    node_root: RootVue,
    node_documents: DocumentsVue,
    node_resources: ResourcesVue,
  },

  computed: {
    context() {
      return ReportStore;
    },

    title() {
      // const provider = ReportStore.surveyParticipation
      //   ? this.$translate(
      //       ReportStore.surveyParticipation?.serviceprovider?.name
      //     )
      //   : this.$tc('page.survey.details.previewTab');
      const survey = this.$translate(ReportStore.survey?.name?.public);
      return `${survey}`;
    },

    content(): ReportNode | undefined {
      if (ReportStore.nodes) {
        const path = SurveyNodeUtils.parsePath(
          ReportStore.path,
          ReportStore.nodes
        );
        if (path.length > 0) {
          return path[0];
        }
      }
    },
  },

  data(): {
    ready: boolean;
  } {
    return {
      ready: false,
    };
  },

  async mounted() {
    try {
      if (ReportStore.survey) {
        const resp = await Promise.all([
          ReportStore.surveyParticipation
            ? SubOrganizationUtils.api.list({
                surveyparticipationid: ReportStore.surveyParticipation?.id,
              })
            : undefined,
          ReportStore.surveyParticipation
            ? PointsOfServiceUtils.api.list({
                surveyparticipationid: ReportStore.surveyParticipation?.id,
              })
            : undefined,
          ReportStore.surveyParticipation?.submissionstate?.id
            ? SurveyUtils.api.surveyState.get(
                ReportStore.surveyParticipation.submissionstate.id as number
              )
            : undefined,
        ]);

        ReportStore.suborganizations = resp[0] as SubOrganization[];
        ReportStore.pointsofservices = resp[1] as PointsOfService[];

        if (ReportStore.surveyParticipation) {
          ReportStore.surveyParticipation.submissionstate = resp[2] as SurveyState;
        }

        if (ReportStore.survey) {
          ReportStore.survey.layout = Array.from(ReportStore.survey.layout); // force nodes to recompute and rerender
        }
        this.ready = true; // dont render until everything is ready
      }
    } catch (error) {
      this.$alert.show('mount', {
        type: 'error',
        messages: this.$handleAPIError(error),
      });
    }
  },

  methods: {},
});

const flatten = (nodes: ReportNode[]) => {
  const reducer = (result: ReportNode[], current: ReportNode) => {
    result.push(current);
    if (current.children?.length > 0) {
      current.children.reduce(reducer, result);
    }
    return result;
  };
  return nodes.reduce(reducer, []);
};
